<template>
	<div>
	<breadcrumbs />

	<loading :active.sync="isLoading"></loading>

	<div class="content-i">
		<div class="content-box">
			<div class="row pt-4">
				<div class="col-sm-12">

					<div class="element-wrapper">

						<h6 class="element-header" v-b-toggle.filter variant="primary">
							{{ t.navigation.bet_trends }}
						</h6>
						<div class="element-box-tp">
							<table-component

									v-if="status == 200"
									table-class="table table-padded"
									filter-input-class="form-control col-4 float-right rounded bright"
									:data="data"
									sort-by="played"
									sort-order="desc"
							>

								<table-column :label="t.bet_market" show="name" >
								</table-column>

								<table-column :label="t.played_bets" show="played" cell-class="w150 text-right">
								</table-column>

								<table-column :label="t.betting.cancelled" show="cancelled" cell-class="w50 text-right">
								</table-column>

								<table-column :label="t.betting.win" show="win" cell-class="w50 text-right">
								</table-column>

								<table-column :label="t.betting.loss" show="loss" cell-class="w50 text-right">
								</table-column>

								<table-column :label="t.betting.waiting" show="waiting" cell-class="w50 text-right">
								</table-column>

								<table-column :label="t.total" show="total" cell-class="w50 text-right">
									<template scope="row">
										{{ (row.waiting + row.loss + row.win + row.cancelled) }}
									</template>
								</table-column>

								<table-column :label="t.total_odd" cell-class="w150 text-right">
									<template scope="row">
										<span> <router-link :to="{params: {market: row.id}, query: $route.query}">{{ (row.totalOdd) }}</router-link></span>
									</template>
								</table-column>

								<table-column label="%" cell-class="w50 text-right">
									<template scope="row">
										<router-link :to="{params: {market: row.id}, query: $route.query}">{{ (row.waiting + row.loss + row.win + row.cancelled) | percentage(totalPlayed) }}%</router-link>
									</template>
								</table-column>

							</table-component>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!--------------------
			START - Sidebar
			-------------------->
		<div class="content-panel compact">
			<div class="content-panel-close" v-on:click="controlPanel">
				<i class="ti-shift-right"></i>
			</div>
			<div class="element-wrapper">

				<h6 class="element-header" v-b-toggle.filter variant="primary">
					{{ t.filter.title }}
				</h6>
				<div class="element-box-tp">

					<form class="justify-content-sm-end">
						<select class="form-control form-control-sm form-control-faded" v-model="selectedPeriod">
							<option v-for="option in accountingPeriods" v-bind:value="option.value">
								{{ t.filter.accounting[option.value] }}
							</option>
						</select>
					</form>

					<div class="box-list mt-3">
						<ul class="vibe-list">
							<li class="b-b" :class="(s.id == sport) ? 'active' : ''" v-for="s in sports">
								<a href="javascript:;" v-on:click="sport = s.id">{{ s.nameLn }}</a>
							</li>
						</ul>
					</div>

				</div>
			</div>
		</div>
		<!--------------------
		END - Sidebar
		-------------------->
	</div>

		<sweet-modal ref="playedBets"  v-on:close="closeModal">
			<playedBets :period="selectedPeriod" :market="$route.params.market" />
		</sweet-modal>

	</div>
</template>

<script>
	import playedBets from '@/components/reports/playedBets'
    import formatter from '@/mixins/formatter'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'playedMarkets',
        components: { 'table-component': TableComponent, 'table-column': TableColumn, playedBets},
        mixins: [formatter],
        data () {
            return {
                isLoading: false,
                t: this.$root.t,
                data: '',
	            status: 0,
                w: window.innerWidth,
                totalPlayed: 0,
                selectedPeriod: 'today',
                accountingPeriods: [
                    { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ],
	            sports: null,
	            sport: 1,
	            match: null
            }
        },
	    watch: {
            '$route.query' () {
                this.fetchReport()
            },
            '$route.params.market' () {
                this.$refs.playedBets.open()
            },
            'selectedPeriod' (o,n) {
                this.$route.query.period = o;
                this.fetchReport()
            },
		    'sport' () {
                this.$route.query.sport = this.sport;
                this.fetchReport()
		    }
	    },
	    mounted () {
            this.selectedPeriod = (this.$route.query.period) ? this.$route.query.period : this.selectedPeriod;
            this.match = (this.$route.query.match) ? this.$route.query.match : this.match;
            this.fetchSports()
			this.fetchReport()
	    },
	    methods: {
            closeModal () {
              this.$router.push({ params: {market: '*'}, query: this.$route.query });
                setTimeout( () => {
                    window.document.body.style.overflow = 'auto';
            }, 500);
            },
			fetchReport () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/analytics/bet/markets', {params: this.$route.query }).then(response => {
                    // get body data
                this.data = response.body.result;
                this.totalPlayed = response.body.totalPlayed;
                this.isLoading = false;
                this.status = response.status;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
			},
		    fetchSports () {
                this.$http.get(api+'api/v1/fixture/sport?per_page=100').then(response => {
                    // get body data
                this.sports = response.body.result.sport;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
		    }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/playedMarkets.vue